import { Box, BoxProps, Flex, FlexProps, SkipNavContent, SkipNavLink } from '@chakra-ui/react';
import { forwardRef, PropsWithChildren, useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Sidebar } from '../sidebar';

const App = ({ children, ...rest }: FlexProps) => (
  <Flex h="100vh" {...rest}>
    {children}
  </Flex>
);
const AppBody = ({ children, ...rest }: BoxProps) => (
  <Box h="100vh" overflow="auto" {...rest}>
    {children}
  </Box>
);
const AppContent = forwardRef<HTMLDivElement, BoxProps>(({ children, ...rest }, ref) => (
  <Box {...rest} ref={ref}>
    {children}
  </Box>
));
AppContent.displayName = 'AppContent';

export const AppLayoutMd = (props: PropsWithChildren): React.ReactNode => {
  const [isExpanded, setIsExpanded] = useState<boolean>(true);
  const location = useLocation();
  const scrollContainer = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (scrollContainer?.current) {
      scrollContainer.current.scrollTop = 0;
    }
  }, [location]);

  const sidebarWidth = isExpanded ? '20%' : '5rem';

  return (
    <>
      <SkipNavLink zIndex={9999}>Skip to content</SkipNavLink>
      <App>
        <Box h={'100vh'} w={sidebarWidth} maxW={'250px'}>
          <Sidebar isExpanded={isExpanded} onSidebarExpand={() => setIsExpanded(!isExpanded)} />
        </Box>
        <AppBody px={6} w="100%">
          <SkipNavContent />
          <AppContent ref={scrollContainer}>{props.children}</AppContent>
        </AppBody>
        {/* <AppPopups />
          <AppDrawers /> */}
      </App>
    </>
  );
};

export default AppLayoutMd;
